import {createContext, useContext} from 'react';
import {contextStubFunction} from './helpers/context';
import {devLog} from './helpers/dev';

type Analytics = {
  action: (event: string, properties?: Record<string, unknown>) => void;
  viewed: (event: string, properties?: Record<string, unknown>) => void;
};

const DefaultAnalytics: Analytics = {
  action: contextStubFunction('Analytics', 'action'),
  viewed: contextStubFunction('Analytics', 'viewed'),
};

const DevLogAnalytics: Analytics = {
  action: (event: string, properties?: Record<string, unknown>) => {
    devLog(
      'Analytics action called, event: ',
      event,
      ' properties: ',
      properties,
    );
  },
  viewed: (event: string, properties?: Record<string, unknown>) => {
    devLog(
      'Analytics viewed called, event: ',
      event,
      ' properties: ',
      properties,
    );
  },
};

const AnalyticsContext = createContext<Analytics>(DefaultAnalytics);

type Props = {
  analytics?: Analytics;
  children: React.ReactNode;
};

export function AnalyticsProvider({analytics, children}: Props) {
  return (
    <AnalyticsContext.Provider value={analytics || DevLogAnalytics}>
      {children}
    </AnalyticsContext.Provider>
  );
}

export function useAnalytics() {
  return useContext(AnalyticsContext);
}
